import axios from 'axios'
import {ENDPOINT} from '@/shared/constants'

export const AXIOSAPI = axios.create({
  baseURL: '/' + ENDPOINT
})

AXIOSAPI.interceptors.response.use(response => {
  return response
}, function (error) {
  if (error.response.status === 401) {
    var ref = window.location.href
    var splitRef = ref.split('#/')
    var currentPath = splitRef[1]
    var basePath = splitRef[0]
    if (currentPath.includes('referer=')) {
      // In case of a double redirect, take the first one.
      currentPath = currentPath.split('referer=')[1]
    }
    var path = basePath + '#/login?referer=' + currentPath
    window.location.href = path
  }
  return Promise.reject(error)
})

class ApiRequests {
  static deleteFile (id) {
    var url = 'files/' + id
    return AXIOSAPI.delete(url)
  }

  static getFile (id) {
    var params = {}
    var url = 'files/' + id
    return AXIOSAPI.get(url, { responseType: 'arraybuffer', 'params': params })
  }

  static getFileMeta (id) {
    var params = {}
    var url = 'files/' + id + '/meta'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getRoles () {
    var params = {}
    var url = 'roles'
    params.sort = 'name'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static deleteUser (id) {
    var url = 'users/' + id
    return AXIOSAPI.delete(url)
  }

  static getUser (id) {
    var url = 'users/' + id
    return AXIOSAPI.get(url)
  }

  static getUsers () {
    var params = {}
    var url = 'users'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static postUser (user, email) {
    var params = {}
    if (email) {
      params.email = true
    }
    var url = 'users'
    return AXIOSAPI.post(url, user, { 'params': params })
  }

  static putUser (user) {
    var params = {}
    var url = 'users/' + user.id
    return AXIOSAPI.put(url, user, { 'params': params })
  }
}

export default ApiRequests



// WEBPACK FOOTER //
// ./src/api/ApiRequests.js